export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function draw(): Promise<void> {
  return delay(0);
}
